var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 957 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_448_266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 957,
    height: 1080
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 957,
    height: 1080,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_448_266)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 963,
    height: 1080,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.6 430.991C1433.6 851.36 1092.82 1192.14 672.449 1192.14C252.079 1192.14 -88.6982 851.36 -88.6982 430.991C-88.6982 10.6207 252.079 -330.156 672.449 -330.156C1092.82 -330.156 1433.6 10.6207 1433.6 430.991Z",
    stroke: "#F3F3F3",
    strokeWidth: 397
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin1);
export default __webpack_public_path__ + "static/media/login1.2a3ea9c05edee1a47e42ff9101bc94a1.svg";
export { ForwardRef as ReactComponent };